import { convertToSignedUrl } from './wasabiHelper';

export function getSafeImageUrl(url) {
    if (!url) return url;
    if (
        url.includes('wasabisys.com') ||
        url.includes('airsmart') ||
        !url.includes('://')
    ) {
        return convertToSignedUrl(url);
    }
    return url;
} 